export default "__VITE_ASSET__6Eizfe$Y__";